import { render, staticRenderFns } from "./BIApprovalTable.vue?vue&type=template&id=349128c6&"
import script from "./BIApprovalTable.vue?vue&type=script&lang=js&"
export * from "./BIApprovalTable.vue?vue&type=script&lang=js&"
import style0 from "./BIApprovalTable.vue?vue&type=style&index=0&id=349128c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports